import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'
import React, { useCallback, useRef, useState } from 'react'
import MerchandiseSearchDropdownInput from './MerchandiseSearchDropdownInput'
import { formToObject } from 'lib/forms/formToObject'
import { useAppDispatch } from 'hooks/reduxHooks'
import { pushWithRegion } from 'actions/NavigationActions'
import qs from 'qs'
import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { MIN_MERCHANDISE_SEARCH_LENGTH } from '../MerchandiseSearchPage/merchandiseSearchPageUtils'

interface Props {
  onInputClick?: React.MouseEventHandler<HTMLInputElement>
}

function MerchandiseSearchForm(props: Props) {
  const { onInputClick } = props
  const containerRef = useRef<HTMLFormElement>(null)
  const dispatch = useAppDispatch()
  const [error, setError] = useState<string | undefined>()

  const onSubmit = useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = formToObject<{ search: string }>(e.currentTarget)
    const text = formData.search?.trim() || undefined

    // Validate minimum search length
    if (text && text.length < MIN_MERCHANDISE_SEARCH_LENGTH) {
      setError(`Please enter at least ${MIN_MERCHANDISE_SEARCH_LENGTH} characters to search`)
      return
    }

    setError(undefined)
    dispatch(pushWithRegion('/search/shop', qs.stringify({ search: text })))
  }, [dispatch])

  return <form onSubmit={onSubmit} ref={containerRef}>
    <VerticalSpacer gap={8}>
      <Group direction="horizontal" gap={16} verticalAlign="center">
        <MerchandiseSearchDropdownInput
          anchorRef={containerRef}
          onClick={onInputClick}
        />
        <TextButton kind="primary" size="large" type="submit">
          Search
        </TextButton>
      </Group>
      {error && <BodyText variant="small" colour="critical">
        {error}
      </BodyText>}
    </VerticalSpacer>
  </form>
}

export default MerchandiseSearchForm
